/** Styles for Settings > Hunts app keys. `ak-` prefix, tokens only. */
export const APP_KEYS_CSS = `
.ak-page { display: flex; flex-direction: column; gap: var(--space-3); max-width: 640px; }
.ak-title { margin: 0; font-size: var(--text-lg, 16px); font-weight: 600; color: var(--text); }
.ak-sub { margin: 0; font-size: var(--text-sm, 12px); color: var(--text-muted); line-height: 1.5; }
.ak-card {
  display: flex; flex-direction: column; gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--bg2); border: 1px solid var(--border); border-radius: var(--radius);
}
.ak-card-head { display: flex; align-items: center; justify-content: space-between; gap: var(--space-2); flex-wrap: wrap; }
.ak-card-name { margin: 0; font-size: var(--text-base); font-weight: 600; color: var(--text); }
.ak-meta { margin: 0; color: var(--text-muted); font-size: var(--text-sm, 12px); }
.ak-steps { margin: 0; padding-left: var(--space-4); display: flex; flex-direction: column; gap: var(--space-2); font-size: var(--text-base); color: var(--text); line-height: 1.5; }
.ak-steps a { color: var(--accent, var(--text)); }
.ak-copy { display: flex; align-items: center; gap: var(--space-2); flex-wrap: wrap; margin-top: var(--space-1); }
.ak-code {
  font-family: var(--font-mono, monospace); font-size: var(--text-sm, 12px);
  padding: var(--space-1) var(--space-2); background: var(--bg3, var(--bg)); border: 1px solid var(--border);
  border-radius: var(--radius); overflow-wrap: anywhere;
}
.ak-form { display: flex; flex-direction: column; gap: var(--space-2); }
.ak-field { display: flex; flex-direction: column; gap: var(--space-1); font-size: var(--text-sm, 12px); color: var(--text-muted); }
.ak-field input {
  font: inherit; font-size: var(--text-base); color: var(--text);
  padding: var(--space-2); background: var(--bg); border: 1px solid var(--border); border-radius: var(--radius);
}
.ak-actions { display: flex; flex-wrap: wrap; gap: var(--space-2); }
.ak-actions .add-btn { margin-left: 0; }
.ak-error { color: var(--red); font-size: var(--text-sm, 12px); }
`
